import { useState } from 'react';
import { firebaseInstance, ui } from '../../fbase';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  //sign up
  firebaseInstance
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .then((user) => {
      console.log(user);
    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
      if (errorMessage.length) {
        setError(errorMessage);
      }
    });
  console.log(error);
  const handleChange = (e) => {
    if (e.target.id === 'email') {
      setEmail(e.target.value);
    } else if (e.target.id === 'password') {
      setPassword(e.target.value);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    setError('');
  };

  return (
    <div className="loginform__container">
      <div className="loginform__wrapper">
        <div className="loginform__form">
          <form className="loginform__input column">
            <div className="loginform__inputs row">
              <input
                type="email"
                id="email"
                placeholder="Email"
                value={email}
                onChange={handleChange}
              />
              <input
                type="password"
                id="password"
                placeholder="Password"
                value={password}
                onChange={handleChange}
              />
            </div>
            <div className="loginform__error">
              <span>{error || ''}</span>
            </div>
            <div className="loginform__submit row">
              <input type="submit" onClick={handleClick} value="로그인" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
